import { render, staticRenderFns } from "./BlogManagement.vue?vue&type=template&id=835b6140&scoped=true&"
import script from "./BlogManagement.vue?vue&type=script&lang=js&"
export * from "./BlogManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "835b6140",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/coachingclub/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('835b6140')) {
      api.createRecord('835b6140', component.options)
    } else {
      api.reload('835b6140', component.options)
    }
    module.hot.accept("./BlogManagement.vue?vue&type=template&id=835b6140&scoped=true&", function () {
      api.rerender('835b6140', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Admin/Blog/BlogManagement.vue"
export default component.exports